export default __webpack_public_path__ + "static/media/market.b1bc36c0.svg";